import { useState, useEffect, useContext, use } from 'react';
import partCodesService from 'services/part-code-service';
import { AuthContext } from 'context';

// MUI and Material Dashboard Components
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import MDBox from 'components/MDBox';
import FormControl from '@mui/material/FormControl';
import MDTypography from 'components/MDTypography';
import { InputLabel } from '@mui/material';
import { render } from '@testing-library/react';


export default function EditUniqueNumDialog({
    handleClose,
    open,
    part
}) {
    const [availableUniqueNums, setAvailableUniqueNums] = useState([]);
    const [selectorOptions, setSelectorOptions] = useState([]);
    const [selectedUniqueNum, setSelectedUniqueNum] = useState(part.unique_num || "");

    useEffect(() => {
        if (part?.partCategory?._id) {
            (async () => {
                try {
                    const response = await partCodesService.getAvailableUniqueNumbers(part.partCategory._id);
                    setAvailableUniqueNums(response.data.attributes);
                } catch (error) {
                    console.error("Error fetching available unique numbers:", error);
                }
            })();
        }
    }, [part.partCategory]);

    useEffect(()=>{
        setSelectorOptions(renderOptions());
    }, [availableUniqueNums]);

    const renderOptions = () => {
        return availableUniqueNums.map((num) => (
            <MenuItem key={num} value={num}>
                {num.toString().padStart(5, '0')}
            </MenuItem>
        ));
    }

    const onSubmit = () => {
        setSelectedUniqueNum("");
        setSelectorOptions([]);
        handleClose(selectedUniqueNum);
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Modify PartCode's Unique Number</DialogTitle>

            <DialogContent>

                <MDBox>
                    <MDTypography
                        variant="body2"
                        color="text"
                        fontWeight="light"
                        mb={1}
                    >
                        Please select a unique number from the available ones below.
                        (Please note that the previous unique number will become available again)
                    </MDTypography>
                </MDBox>

                <MDBox>
                    <FormControl fullWidth>
                        <InputLabel id="unique-number-label">Unique Number</InputLabel>
                        <Select
                            value={selectedUniqueNum}
                            labelId="unique-number-label"
                            label="Unique Number"
                            id="unique-number-select"
                            onChange={(e) => setSelectedUniqueNum(e.target.value)}
                            sx={{ height: '45px', '& .MuiSelect-select': { paddingY: '8px' } }}
                        >
                            {selectorOptions}
                        </Select>
                    </FormControl>
                </MDBox>

            </DialogContent>
            <DialogActions>

                <Button onClick={handleClose}>Cancel</Button>
                <Button onClick={onSubmit}>Save</Button>

            </DialogActions>

        </Dialog>
    )
}